import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CoreSidebarService} from '../../../../@core/components/core-sidebar/core-sidebar.service';
import {AlertService} from '../../../shared/services/alert.service';
import {AuthorService} from '../../../shared/services/author.service';

@Component({
    selector: 'app-add-author',
    templateUrl: './add-author.component.html',
    styleUrls: ['./add-author.component.scss']
})

export class AddAuthorComponent implements OnChanges {
    addAuthorForm: FormGroup;
    submitted: any = false;
    submitting: any = false;
    onFileChanged: any;
    fileProfilePhoto: any;
    @Output() valueSubmitted = new EventEmitter<any>();
    @Input() data: any;

    constructor(private _coreSidebarService: CoreSidebarService,
                private fb: FormBuilder,
                private alertService: AlertService,
                private authorService: AuthorService) {
    }

    ngOnChanges(): void {
        this.refresh();
    }

    toggleSidebar(): void {
        this._coreSidebarService.getSidebarRegistry('add-author').toggleOpen();
    }

    refresh() {
        this.addAuthorForm = this.fb.group({
            'name': ['', Validators.required],
            'username': ['', Validators.required],
            'email': ['', Validators.compose([Validators.required, Validators.pattern('^(([^<>()[\\]\\\\.,;:\\s@\\"]+(\\.[^<>()[\\]\\\\.,;:\\s@\\"]+)*)|(\\".+\\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$')])],
            'contact': ['', Validators.compose([Validators.required, Validators.pattern('^[5-9]{1}[0-9]{9}$')])],
        });
        if (this.data && this.data['id']) {
            this.patchForm();
        } else {
            this.fileProfilePhoto = undefined;
        }
    }

    patchForm() {
        this.fileProfilePhoto = (this.data && this.data['profile_photo']) ? this.data['profile_photo'] : undefined;
        this.addAuthorForm.patchValue({
            'name': (this.data && this.data['name']) ? this.data['name'] : '',
            'username': (this.data && this.data['username']) ? this.data['username'] : '',
            'email': (this.data && this.data['email']) ? this.data['email'] : '',
            'contact': (this.data && this.data['contact']) ? this.data['contact'] : '',
        });
    }

    onFileChange(e, type) {
        this.onFileChanged = e;
        const params: any = {'type': type, 'fileType': 'NORMAL'};
        if (this.data && this.data['id']) {
            params.author_id = this.data['id'];
        }
        this.authorService.fileUploadAdmin(params, this.onFileChanged).subscribe(data => {
            if (type === 'AUTHOR_PROFILE_PHOTO') {
                this.fileProfilePhoto = data['data'];
            }
            this.alertService.showSuccess({title: 'Success', message: 'Uploaded Successfully'});
        }, error => {
            this.alertService.showErrors('Something went wrong, please try again');
        });
    }

    openProfilePhoto() {
        window.open(this.fileProfilePhoto['url'], '_blank');
    }

    submit() {
        this.submitted = true;
        if (!this.addAuthorForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'name': (this.addAuthorForm.value && this.addAuthorForm.value.name) ? this.addAuthorForm.value.name : '',
                'username': (this.addAuthorForm.value && this.addAuthorForm.value.username) ? this.addAuthorForm.value.username : '',
                'email': (this.addAuthorForm.value && this.addAuthorForm.value.email) ? this.addAuthorForm.value.email : '',
                'contact': (this.addAuthorForm.value && this.addAuthorForm.value.contact) ? this.addAuthorForm.value.contact : '',
                'profile_photo': (this.fileProfilePhoto) ? this.fileProfilePhoto.id : '',
            };
            this.submitting = true;
            this.authorService.create(params).subscribe(data => {
                if (data) {
                    this.submitting = false;
                    this.submitted = false;
                    this.valueSubmitted.emit(true);
                    this.addAuthorForm.reset();
                    this.fileProfilePhoto = undefined;
                }
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].username && error['error']['errors'].username.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].username[0]);
                        return;
                    }
                    if (error['error']['errors'].email && error['error']['errors'].email.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].email[0]);
                        return;
                    }
                    if (error['error']['errors'].contact && error['error']['errors'].contact.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].contact[0]);
                        return;
                    }
                }
            });
        }
    }

    update() {
        this.submitted = true;
        if (!this.addAuthorForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'name': (this.addAuthorForm.value && this.addAuthorForm.value.name) ? this.addAuthorForm.value.name : '',
                'username': (this.addAuthorForm.value && this.addAuthorForm.value.username) ? this.addAuthorForm.value.username : '',
                'email': (this.addAuthorForm.value && this.addAuthorForm.value.email) ? this.addAuthorForm.value.email : '',
                'contact': (this.addAuthorForm.value && this.addAuthorForm.value.contact) ? this.addAuthorForm.value.contact : '',
                'profile_photo': (this.fileProfilePhoto) ? this.fileProfilePhoto.id : '',
            };
            this.submitting = true;
            this.authorService.update(this.data['id'], params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.valueSubmitted.emit(true);
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].username && error['error']['errors'].username.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].username[0]);
                        return;
                    }
                    if (error['error']['errors'].email && error['error']['errors'].email.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].email[0]);
                        return;
                    }
                    if (error['error']['errors'].contact && error['error']['errors'].contact.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].contact[0]);
                        return;
                    }
                }
            });
        }
    }
}
